export namespace IMovementsReport {
  export interface IDataItem {
    balance: number;
    paySum?: number;
    carNumber: string;
    carId: number;
    comment: string;
    corpName: string;
    dateIn: string;
    dateOut: string;
    dateHandUpd?: string;
    dayInMonth: number;
    movId: number;
    orderCalc: string;
    persName: string;
    timePark: string;
    hasPhoto?: boolean;
    finalScore?: boolean;
    corpId?: number;
    parentId?: number;
    payType?: PayType;
    driverSum?: number;
    subParkSum?: number;
    saldo?: number;
    payGuestHoursMov?: number;
    unknownCarFlag?: boolean;
    bankPayFlag?: boolean;
    camCarNumber?: string;
    payCashFlag?: boolean;

    subMovFlag?: boolean;
    movIds: number[];

    // FE props.
  }

  export interface ITableTotal {
    balance: number;
    dayInMonth: number;
    driverSum: number;
    limitCntRows: number;
    limitMessageFlag: boolean;
    paySum: number;
    saldo: number;
    subParkSum: number;
    totalRows: number;
  }

  export interface ICarPopupTableItem {
    movId: number;
    carNumber: string;
    dateBeg: string;
    dateEnd: string;
    dateHandUpd?: string;
    hour: string;
    tSum: string;
    orderby: string;
    parkName: string;
    hasPhoto: boolean;
    returnFlag?: boolean;
    finalScore?: boolean;
    corpId: number;
    corpName: string;
    comment?: string;
    paySum?: number;
    payType?: IMovementsReport.PayType;
  }

  export interface ICarPopupTableItemPrint extends ICarPopupTableItem {
    datePrint: string;
    dateBegPrint: string;
    dateEndPrint: string;
    corpPrint: string;
    tSumPrint: string;
    paySumPrint: string;
  }

  export enum PayType {
    qr = 'qr',
    terminal = 'terminal',
    autopay = 'autopay',
    cash = 'cash',
    noPay = 'noPay',
    multiPay = 'multiPay',
  }

  export enum TableConfigType {
    Default = 0,
    WithKPPAndDriver = 1,
  }

  export const PayTypeIcons = {
    [PayType.qr]:       { name: 'qrcode',       color: 'main',    label: 'QR-код', },
    [PayType.terminal]: { name: 'credit-card',  color: 'orange',  label: 'Картой', },
    [PayType.autopay]:  { name: 'id-card',      color: 'orange',  label: 'Автоматическая оплата', },
    [PayType.cash]:     { name: 'money-bill-1', color: 'green',   label: 'Наличными', },
    [PayType.noPay]:    { name: 'ban',          color: 'red',     label: 'Без оплаты', },
    [PayType.multiPay]: { name: 'coins',        color: 'red',     label: 'Разными типами', },
  };
}